import { mapActions } from 'vuex'
import { ACCOUNTS_CLEAR, ACCOUNTS_LIST } from 'store/types'

export default
{
	methods:
	{
		...mapActions
		(
			{
				clearAccounts: ACCOUNTS_CLEAR,
				loadAccounts:  ACCOUNTS_LIST,
			}
		),
	},

	mounted()
	{
		this.loadAccounts()
	},

	beforeDestroy()
	{
		this.clearAccounts()
	},
}